import { render, staticRenderFns } from "./TreeElement.vue?vue&type=template&id=0f8df12a"
import script from "./TreeElement.vue?vue&type=script&lang=js"
export * from "./TreeElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports